import { gql } from '@apollo/client';

export const EscrowMembershipFragment = gql`
  fragment EscrowMembershipFragment on EscrowMembership {
    id
    role
    appSubscription {
      id
      user {
        id
        name
        email
        phone
        role
      }
    }
    policy {
      remove
      update
    }
  }
`;
